import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import { ROUTE_DENIED } from 'constants/routerPath';

const adminRoles = ['can_dispatch_guard_v3_admin'];

function useAnnouncementAdminAccess() {
  const { userInfo } = useSelector(selectUserInfo);
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!userInfo.contactId) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasAdminRole = userInfo.roles.some((role: any) =>
      adminRoles.includes(role),
    );

    // Also allow users in the 'Admins' role group
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasAdminsGroup = userInfo.roleGroups?.some((group: any) =>
      group === 'Admins',
    );

    const isAllowed = hasAdminRole || hasAdminsGroup;

    if (!isAllowed) {
      navigate(ROUTE_DENIED);
    }

    setIsAdmin(isAllowed);
  }, [navigate, userInfo]);

  return { isAdmin };
}

export default useAnnouncementAdminAccess;
